module.exports = __webpack_public_path__ + "de.svg?5882454ca1bc6680b044ceea311e25dd";